import PageHeader from "@/components/PageHeader";
import ApproachTimeline from "@/components/sections/ApproachTimeline";
import WhyUs from "@/components/sections/WhyUs";
import AssessmentCTA from "@/components/sections/AssessmentCTA";

export default function Approach() {
    return (
        <>
            <PageHeader
                eyebrow="Our Approach"
                titleLines={["From repetitive work", "to measurable value"]}
                description="A deliberate, low-risk method. We automate one workflow first, prove the value, then scale, always inside your existing systems."
            />
            <ApproachTimeline showHeader={false} />
            <WhyUs />
            <AssessmentCTA />
        </>
    );
}
